import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { firstValueFrom } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NzModalService } from 'ng-zorro-antd/modal';
import { environment } from '../../../../environments/environment';
import { ArchivosService } from '../../services/archivos.service';
import { AutoportalService } from '../../services/autoportal.service';
import { bodyBusquedaFactura, bodyBusquedaTicket, ConfigAutoportal, ConfigInitial, FacturaConsultada } from '../../models';
import { LoginService } from '../../services/login.service';

@Component({
  selector: 'app-drawer-consulta-factura',
  standalone: false,
  templateUrl: './drawer-consulta-factura.component.html',
  styleUrl: './drawer-consulta-factura.component.scss'
})
export class DrawerConsultaFacturaComponent implements OnInit {
  public visible: boolean = false;
  public isMobile: boolean = false;
  public isCollapsed: boolean = true;
  public facturaConsultada!: FacturaConsultada;
  public formEmail: FormGroup;
  public isLoading: boolean = false;
  public configInitial!: ConfigInitial;
  public configAutoportal!: ConfigAutoportal;
  public nombreXML: string = "";
  public nombrePDF: string = "";
  public searchingTicket: boolean = false;
  @Input() public formTicket!: FormGroup;
  @Output() public isSearchingInvoice: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private notificationMessage: NzNotificationService,
    private archivosService: ArchivosService,
    private autoportalService: AutoportalService,
    private loginService: LoginService,
    private http: HttpClient,
    private modalService: NzModalService,
  ) {
    this.formEmail = new FormGroup({
      email: new FormControl([], [
        Validators.required
      ])
    });

    const configInitialStorage: any = localStorage.getItem("configInicial");
    this.configInitial = JSON.parse(configInitialStorage);
  }

  ngOnInit(): void {
    if (window.innerWidth >= 768) {
      this.isMobile = false;
    } else {
      this.isMobile = true;
    }
  }

  public open(): void {
    this.formTicket.markAllAsTouched();
    const montoInicial = parseFloat(this.formTicket.get('montoTotal')?.value);

    if (this.formTicket.valid === true) {
      this.searchingTicket = true;

      const formData: bodyBusquedaTicket = {
        montoTotal: montoInicial,
        referencia: this.formTicket.value['referencia'],
        rfcReceptor: this.formTicket.value['rfcReceptor'],
        rfcEmisor: this.formTicket.value['rfcEmisor']
      };

      this.loginService.buscarConfiguracionTicket(formData).subscribe(
        response => {
          const responseIDConfig: string = response;

          this.autoportalService.getConfigAutoportal(responseIDConfig).subscribe(
            response => {
              this.configAutoportal = response;
              this.getDataFactura(formData);
            }
          )
        }, (errorBusqueda: any) => {
          this.searchingTicket = false;
          switch (errorBusqueda.status) {
            case 404:
              this.loginService.getMensajePersonalizado(this.configInitial.rfcEmisor, 'TICKET_404').subscribe(
                responsePersonalizado => {
                  this.modalService.error({
                    nzTitle: responsePersonalizado.header,
                    nzContent: `<p>${responsePersonalizado.content}</p> <p>${responsePersonalizado.footer}</p>`,
                    nzCentered: true
                  });
                }, (error: any) => {                  
                  this.modalService.error({
                    nzTitle: '¡Error!',
                    nzContent: JSON.parse(errorBusqueda.error).detail,
                    nzCentered: true
                  });
                }
              )
              break;
            default:
              this.modalService.error({
                nzTitle: '¡Error!',
                nzContent: JSON.parse(errorBusqueda.error).detail,
                nzCentered: true
              });
              break;
          }
        }
      )
    } else {
      this.notificationMessage.error('¡Alerta!', 'Completa los campos correctamente para continuar.');
    };
  };

  public close(): void {
    this.isCollapsed = true;
    this.formEmail.reset();
    this.visible = false;
  }

  public downloadPDF(url_pdf: string, nombre: string): void {
    this.archivosService.getPDFByUrl(url_pdf.replace('/api/v1/archivo?', '/api/v1/archivo/contenido?')).subscribe(
      response => {
        // Crear un array de bytes a partir de la cadena base64
        const byteCharacters = atob(response);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);

        // Crear un objeto Blob
        const blob = new Blob([byteArray], { type: 'application/pdf' });

        // Crear un enlace de descarga
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${nombre}`; // Nombre del archivo a descargar

        // Simular un clic
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    );

  }

  public downloadXML(url_xml: string, nombre: string): void {
    this.archivosService.getXMLByUrl(url_xml.replace('/api/v1/archivo?', '/api/v1/archivo/contenido?')).subscribe(
      response => {
        // Crear un array de bytes a partir de la cadena base64
        const byteCharacters = atob(response);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);

        // Crear un objeto Blob con tipo MIME para XML
        const blob = new Blob([byteArray], { type: 'text/xml' });

        // Crear un enlace de descarga
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${nombre}`; // Nombre del archivo a descargar

        // Simular un clic
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    );
  }

  public getDataFactura(finalFormTicket: bodyBusquedaTicket): void {
    const formData: bodyBusquedaFactura = {
      montoTotal: finalFormTicket.montoTotal,
      referencia: finalFormTicket.referencia,
      rfcReceptor: finalFormTicket.rfcReceptor,
      configuracionGeneral: this.configAutoportal.configuracionGeneral
    };

    this.autoportalService.getFacturaConsulta(formData).subscribe(
      response => {
        this.facturaConsultada = response;
        this.searchingTicket = false;
        this.visible = true;
      }, (err: any) => {
        this.searchingTicket = false;
        this.modalService.error({
          nzTitle: '¡Error!',
          nzContent: err.error.detail,
          nzCentered: true
        });
      }
    )
  }

  public sendEmail(): void {
    this.isLoading = true;
    this.autoportalService.enviarEmail(
      { email: this.formEmail.value['email'], facturaId: this.facturaConsultada.facturaId, identificadorSucursalId: this.configAutoportal.configuracionGeneral.centroConsumoId, identificadorCC: this.configAutoportal.configuracionGeneral.identificadorCC }
    ).subscribe(
      (response: any) => {
        this.notificationMessage.success('¡Enhorabuena!', response.mensaje);
        this.formEmail.reset();
        this.isLoading = false;
      }, (err: any) => {
        this.notificationMessage.error('¡Error!', err.error['mensaje'] + ', por favor, intente de nuevo más tarde.');
        this.isLoading = false;
      }
    );
  }

  public addEmail(): void {
    let arrayEmails: Array<string> = this.formEmail.get('email')?.value;
    let email: any = arrayEmails.at(-1);
    let emailTrim = email.trim();

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    let validacion = emailRegex.test(emailTrim);

    if (!validacion) {
      this.notificationMessage.error('¡Error!', 'Por favor ingresa un email válido.');
      const x = arrayEmails.splice(1, arrayEmails.lastIndexOf(email));
      this.formEmail.controls['email'].setValue(x);
    } else {
      let index = arrayEmails.lastIndexOf(email);
      arrayEmails[index] = emailTrim;
      const tieneDuplicados = arrayEmails.some((item, index) =>
        arrayEmails.indexOf(item) !== index
      );
      if (tieneDuplicados) {
        const x = arrayEmails.splice(1, arrayEmails.lastIndexOf(emailTrim));
        this.formEmail.controls['email'].setValue(x);
      } else {
        this.formEmail.controls['email'].setValue(arrayEmails);
      }
    }
  }

  @HostListener('window:resize', ['$event.target.innerWidth'])
  public onResize(width: number): void {
    if (width >= 768) {
      this.isMobile = false;
    } else {
      this.isMobile = true;
    }
  }
}
